/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { RawSkillAssessmentDto } from '../models';
// @ts-ignore
import type { SkillAssessmentDto } from '../models';
// @ts-ignore
import type { SkillDto } from '../models';
/**
 * RestSkillsApi - axios parameter creator
 * @export
 */
export const RestSkillsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary assess user skills
         * @param {string} userId 
         * @param {Array<RawSkillAssessmentDto>} rawSkillAssessmentDto add user skills assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessUserSkills: async (userId: string, rawSkillAssessmentDto: Array<RawSkillAssessmentDto>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('assessUserSkills', 'userId', userId)
            // verify required parameter 'rawSkillAssessmentDto' is not null or undefined
            assertParamExists('assessUserSkills', 'rawSkillAssessmentDto', rawSkillAssessmentDto)
            const localVarPath = `/api/users/{userId}/skills-assessment`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(rawSkillAssessmentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get active skills
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveSkills: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getActiveSkills', 'userId', userId)
            const localVarPath = `/api/users/{userId}/skills`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary get user skills assessment
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSkillsAssessment: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserSkillsAssessment', 'userId', userId)
            const localVarPath = `/api/users/{userId}/skills-assessment`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * RestSkillsApi - functional programming interface
 * @export
 */
export const RestSkillsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = RestSkillsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary assess user skills
         * @param {string} userId 
         * @param {Array<RawSkillAssessmentDto>} rawSkillAssessmentDto add user skills assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assessUserSkills(userId: string, rawSkillAssessmentDto: Array<RawSkillAssessmentDto>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assessUserSkills(userId, rawSkillAssessmentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestSkillsApi.assessUserSkills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get active skills
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveSkills(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SkillDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveSkills(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestSkillsApi.getActiveSkills']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary get user skills assessment
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserSkillsAssessment(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SkillAssessmentDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserSkillsAssessment(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['RestSkillsApi.getUserSkillsAssessment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * RestSkillsApi - factory interface
 * @export
 */
export const RestSkillsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = RestSkillsApiFp(configuration)
    return {
        /**
         * 
         * @summary assess user skills
         * @param {string} userId 
         * @param {Array<RawSkillAssessmentDto>} rawSkillAssessmentDto add user skills assessment
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assessUserSkills(userId: string, rawSkillAssessmentDto: Array<RawSkillAssessmentDto>, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.assessUserSkills(userId, rawSkillAssessmentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get active skills
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveSkills(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SkillDto>> {
            return localVarFp.getActiveSkills(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary get user skills assessment
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserSkillsAssessment(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SkillAssessmentDto>> {
            return localVarFp.getUserSkillsAssessment(userId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * RestSkillsApi - interface
 * @export
 * @interface RestSkillsApi
 */
export interface RestSkillsApiInterface {
    /**
     * 
     * @summary assess user skills
     * @param {string} userId 
     * @param {Array<RawSkillAssessmentDto>} rawSkillAssessmentDto add user skills assessment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestSkillsApiInterface
     */
    assessUserSkills(userId: string, rawSkillAssessmentDto: Array<RawSkillAssessmentDto>, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary get active skills
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestSkillsApiInterface
     */
    getActiveSkills(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SkillDto>>;

    /**
     * 
     * @summary get user skills assessment
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestSkillsApiInterface
     */
    getUserSkillsAssessment(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SkillAssessmentDto>>;

}

/**
 * RestSkillsApi - object-oriented interface
 * @export
 * @class RestSkillsApi
 * @extends {BaseAPI}
 */
export class RestSkillsApi extends BaseAPI implements RestSkillsApiInterface {
    /**
     * 
     * @summary assess user skills
     * @param {string} userId 
     * @param {Array<RawSkillAssessmentDto>} rawSkillAssessmentDto add user skills assessment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestSkillsApi
     */
    public assessUserSkills(userId: string, rawSkillAssessmentDto: Array<RawSkillAssessmentDto>, options?: RawAxiosRequestConfig) {
        return RestSkillsApiFp(this.configuration).assessUserSkills(userId, rawSkillAssessmentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get active skills
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestSkillsApi
     */
    public getActiveSkills(userId: string, options?: RawAxiosRequestConfig) {
        return RestSkillsApiFp(this.configuration).getActiveSkills(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary get user skills assessment
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof RestSkillsApi
     */
    public getUserSkillsAssessment(userId: string, options?: RawAxiosRequestConfig) {
        return RestSkillsApiFp(this.configuration).getUserSkillsAssessment(userId, options).then((request) => request(this.axios, this.basePath));
    }
}

